import PinchZoom from 'pinch-zoom-element';

const clampNumber = (num, min, max) => Math.min(Math.max(num, min), max);

const init = function(){
  const component = document.querySelector(".product-fullscreen-zoom");
  const buttonsZoom = component.querySelectorAll('.product-zoom-button');
  const currentValue = component.querySelector('.product-zoom-current');
  const zoomImage =  document.querySelector('.product-fullscreen-image');
  const startingPercentage = 100;
  const zoomStep = 10;
  const minScale = 10;
  const maxScale = 300;
  let currentPercentage = startingPercentage;
  const pinchZoom = document.querySelector('.product-fullscreen-pinchable-image');
  pinchZoom.minScale = minScale / 100;
  pinchZoom.addEventListener('change', function(){
    currentPercentage = Math.floor(this.scale * 100);
    currentValue.textContent = currentPercentage;
  });

  function setTransform() {
    const scale = currentPercentage / 100;
    pinchZoom.setTransform({
      scale: scale,
        // Transform origin. Can be a number, or string percent, eg "50%"
        x: (window.innerWidth / 2) - ((zoomImage.clientWidth / 2) * scale),
        y: (window.innerHeight / 2) - ((zoomImage.clientHeight / 2) * scale),
        // Fire a 'change' event if values are different to current values
        allowChangeEvent: true,
    });
  }

  buttonsZoom.forEach(e => 
    e.addEventListener('click', function(e){
      let targetPercentage = currentPercentage + (e.target.dataset.zoom === "plus" ? zoomStep : -zoomStep);
      targetPercentage = clampNumber(targetPercentage, minScale, maxScale );
      currentPercentage = targetPercentage;
      setTransform();
    })
  );

  // IBT-3651
  function setFullScreen() {
    console.debug('setFullScreen zoomImage.naturalWidth zoomImage.naturalHeight', zoomImage.naturalWidth, zoomImage.naturalHeight);
    if (zoomImage.naturalWidth <= 0 || zoomImage.naturalHeight <= 0) {
      return;
    }

    let targetPercentage = Math.min(100.0 * window.innerWidth / zoomImage.naturalWidth, 100.0 * window.innerHeight / zoomImage.naturalHeight);
    targetPercentage = clampNumber(targetPercentage, minScale, maxScale);
    currentPercentage = targetPercentage;
    setTransform();
  }

  const observer = new MutationObserver(mutationList => {
    mutationList.forEach(mutation => {
      console.debug('mutation.attributeName', mutation.attributeName);
      if (!mutation.attributeName.includes('src')){
        return;
      }

      console.debug('zoomImage.complete', zoomImage.complete);
      if (zoomImage.complete) {
        setFullScreen();
      } else {
        zoomImage.addEventListener('load', () => {
          console.debug('zoomImage load');
          setFullScreen();
        }, { once: true });
      }
    });
  });
  observer.observe(zoomImage, { attributes: true });
}

export {init};